import React, { useEffect, useState } from "react";
import { Input } from "antd";
import Image from "../image/Image";
import { get_client } from "../../../api/endpoints/clients";
import { FaImages } from "react-icons/fa";
import { COLORS } from "../../layout/theme";
import { TableContainer, AntdTable } from "./styles";

export default function DistributorsFiltered({
	initialValues = null,
	onChange,
	ean13 = "",
	flag = null,
	background = null,
	containerBackground = null,
	showHeader = true,
}) {
	const [distributors, setDistributors] = useState(null);

	useEffect(() => {
		const fetch_distributors = async () => {
			const res = await get_client();

			setDistributors(
				initialValues
					? res.distributors
							.map((d) => ({
								key: d.id,
								...d,
							}))
							.filter((p) => p.code !== null)
							.map((d) => ({
								...d,
								code: d.eanAutocomplete
									? ean13
									: initialValues?.find((i) => i.id === d.id)?.code,
							}))
					: res.distributors
							.map((d) => ({
								key: d.id,
								...d,
								code: d.eanAutocomplete ? ean13 : d.code,
							}))
							.filter((p) => p.code !== null),
			);
		};

		fetch_distributors();
	}, [ean13, flag]);

	useEffect(() => {
		onChange(distributors);
	}, [distributors]);

	const handleChange = (text, record, index, value) => {
		let items = [...distributors];
		items[index] = {
			...distributors[index],
			code: value,
		};
		setDistributors(items);
	};

	const columns = [
		{
			title: (algo) => {
				return <FaImages style={{ color: COLORS.White }} />;
			},
			dataIndex: "photoUrl",
			key: "photoUrl",
			render: (data) => <Image width={40} height={40} src={data} />,
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Droguería</div>,
			dataIndex: "name",
			key: "name",
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Codigo</div>,
			dataIndex: "code",
			key: "code",
			render: (text, record, index) => (
				<Input
					value={record.eanAutocomplete ? ean13 : text === "si" ? "" : text}
					onChange={(e) => handleChange(text, record, index, e.target.value)}
					disabled={record.eanAutocomplete}
				/>
			),
		},
	];

	if (!distributors) return <div>Loading...</div>;

	return (
		<TableContainer containerBackground={containerBackground}>
			<AntdTable
				size="small"
				columns={columns}
				dataSource={distributors}
				pagination={false}
				background={background}
				showHeader={showHeader}
			/>
		</TableContainer>
	);
}
